import {Log1} from '../../../assets';

export const logs = [
  {
    id: '1',
    version: '2.1.0',
    date: 'November 07, 2023',
    list: [
      {
        id: '1',
        title: 'What’s New',
        items: [
          'We`ve introduced a set of new emoji reactions for chat messages, allowing you to express yourself even more vividly in conversations.',
          'Enhanced user interface for a smoother experience.',
          'Introducing dark mode for better nighttime usage.',
        ],
      },
      {
        id: '2',
        title: 'Bug Fixes',
        items: [
          'Resolved minor bugs affecting message formatting.',
          'Our development team has diligently addressed several minor bugs related to message formatting. This ensures that your messages display correctly and consistently.',
          'Updated the app icon for a fresh look.',
        ],
      },
    ],
  },
  {
    id: '2',
    version: '2.0.8',
    date: 'November 07, 2023',
    img: <Log1 />,
    list: [
      {
        id: '1',
        title: 'What’s New',
        texts: [
          'Choose your own adventure',
          'We are excited to announce that we have implemented support for multiple buttons on chapters, allowing for a more personalized and engaging experience for your audience.',
        ],
      },
      {
        id: '2',
        title: 'Bug Fixes',
        items: [
          'Resolved minor bugs affecting message formatting.',
          'Our development team has diligently addressed several minor bugs related to message formatting. This ensures that your messages display correctly and consistently.',
          'Updated the app icon for a fresh look.',
        ],
      },
    ],
  },
];
